import React from 'react';
import './style/About.css';
import TopNavbar from './TopNavbar';

const About = () => {
  return (
    <div className="about-container">
      <TopNavbar name="About Us" />

      <div className="about-card">

        {/* Legal Disclaimer Box */}
        <div className="disclaimer-box">
          <div className="disclaimer-header">
            <span className="warning-icon">⚠️</span>
            <h2>LEGAL DISCLAIMER</h2>
          </div>
          <p>
            WB Exam Mock Test is an independent educational platform and does not represent a government entity. We are not affiliated with, endorsed by, or connected to the Government of West Bengal or any official exam board.
          </p>
          <div className="official-sources">
            <p><strong>Official Information Sources:</strong></p>
            <ul><br></br>
              <li><strong>WBPSC:</strong> <a href="https://psc.wb.gov.in" target="_blank" rel="noopener noreferrer">psc.wb.gov.in</a></li>
            <br></br>  <li><strong>WBPRB:</strong> <a href="https://prb.wb.gov.in" target="_blank" rel="noopener noreferrer">prb.wb.gov.in</a></li>
             <br></br> <li><strong>WBSSC:</strong> <a href="https://westbengalssc.com" target="_blank" rel="noopener noreferrer">westbengalssc.com</a></li>
            <br></br>  <li><strong>WBMSC:</strong> <a href="https://wbmsc.com" target="_blank" rel="noopener noreferrer">wbmsc.com</a></li>
            </ul>
          </div>
        </div>

        {/* Main Header */}
        <header className="about-header">
          <h1 className="about-title">About WB Exam Mock Test</h1>
          <p className="about-subtitle">
            Your ultimate companion for cracking WBPSC, WBSSC, WBPRB, and WBMSC examinations.
          </p>
        </header>

        {/* Mission Section */}
        <section className="mission-section">
          <h2>Our Mission: Empowering Aspirants of West Bengal</h2>
          <p>
            At WB Exam Mock Test, we believe that high-quality guidance for state competitive exams should be accessible to every aspirant. We provide structured, syllabus-oriented, and completely free mock tests to help you prepare effectively.
          </p>
        </section>

        {/* Features Section */}
        <section className="features-section">
          <h2>Comprehensive Preparation for WB Exams</h2>
          <div className="features-grid">
            <div className="feature-card">
              <span className="feature-tag">Subject Wise</span>
              <h3>Core Subject Mastery</h3>
              <p>Practice for Math, Reasoning, English, and GK tailored to West Bengal exam patterns.</p>
            </div>

            <div className="feature-card">
              <span className="feature-tag">PYQ Archive</span>
              <h3>State-Level PYQs</h3>
              <p>Access Previous Year Questions from Clerkship, Misc, and Police exams.</p>
            </div>

            <div className="feature-card">
              <span className="feature-tag">Full Mock</span>
              <h3>Real-Time Simulation</h3>
              <p>Experience the pressure of the actual exam hall with full-length expert mock tests.</p>
            </div>

            <div className="feature-card">
              <span className="feature-tag">Regional GK</span>
              <h3>WB Special Focus</h3>
              <p>Dedicated West Bengal General Knowledge for state-specific competitive advantage.</p>
            </div>
          </div>
        </section>

        {/* Highlight Stats Banner */}
        <section className="stats-banner">
          <div className="stat-item">
            <span className="stat-number">10,000+</span>
            <span className="stat-label">MCQs Covered</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">All WB Boards</span>
            <span className="stat-label">Mock Content for All</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">100% Free</span>
            <span className="stat-label">For All Aspirants</span>
          </div>
        </section>

        {/* Support Section */}
        <section className="about-contact">
          <p>Have questions or feedback? Contact us at <a href="mailto:support@mystudyplace.in">support@mystudyplace.in</a></p>
        </section>

      </div>
    </div>
  );
};

export default About;